









































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const root = namespace("root");
@Component({})
export default class NewLogin extends Vue {
  @root.State ddCodes;
  isMaintain: any = false;
  stopTime: any = "";
  isInit: any = false;
  async created() {
    this.isMaintain = false;
    if (this.$route.name === "Login") {
      await this.$dd.register(["LOGIN_STOP"]).query();
      let list: any = this.ddCodes.LOGIN_STOP || [];
      if (list.length > 0 && list[0].value === "1") {
        this.isMaintain = true;
        this.stopTime = list[0].label || "";
      }
    }
    this.isInit = true;
  }
}
